import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { userQueryOptions } from './useUser';

export const useSignContract = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request('/user/contract/sign', { method: 'PATCH' });
    },
    onSuccess: () => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => {
        if (!user) return;

        return { ...user, contractSigned: true, addendumSigned: true };
      });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
